import { Component, OnInit } from '@angular/core';
import { JReportPrinterService } from '../../services/jreport-printer.service';
import { PrinterService } from '../../services/printer.service';
@Component({
    selector: 'lfwms-jreport-print',
    templateUrl: './jreport-print.component.html',
    styleUrls: ['./jreport-print.component.css'],
  })
  export class JReportPrintComponent implements OnInit {
  public PrinterServiceData: any;
  public width;
  public height;
  public iframeUrl;
    constructor(printService: JReportPrinterService,printerService: PrinterService) {
        this.PrinterServiceData = printService.data ? printService.data : printerService.data;
    }
    public ngOnInit() {
        this.width = 1000;
        this.height = 600
        this.iframeUrl = this.PrinterServiceData.iframeUrl
        
    }
  }


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/jreport/jreport-print/jreport-print.component.ts